<div class="w-1/2 mt-8 flex bg-gradient-to-t from-headerfr to-headerto"
    style="border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%; transform: translateX(50%);">
    <div class="p-24 text-center justify-center items-center text-yellow-200">
        <h2 class="text-lg font-semibold" style="text-shadow: 4px 4px 8px rgba(0, 0, 0, 0.5);">
            In the FUSILLI project we collected and studied <a
                href='https://fusilli-project.eu/app/uploads/FUSILLI_D2.1_Report-with-5-10-in-deph-case-studies-and-employed-strategies.pdf'
                class="text-white hover:underline">showcases</a>:
            examples of cities and initiatives that are transforming their urban food system. You can find these
            showcases
            here. They can be an inspiration for Living Lab coordinators or facilitators of urban food system
            transformation
            anywhere around the world. You can browse through the showcases in various ways: by typing a keyword that is
            relevant to you in the search bar below, or by selecting particular conditions or features in the left.
        </h2>
    </div>
</div>
<div class="flex flex-col">
    <div class="flex flex-wrap justify-end my-16">
        <button *ngIf="showModerator" routerLink="/Moderator" routerLinkActive="active"
            style="border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;"
            class="mx-1 px-8 py-1 text-xl font-light cursor-pointer bg-headerfr hover:bg-buttonhover text-yellow-200 hover:text-colortext place-self-center mt-4">Manage
            documents</button>
        <button *ngIf="showModerator" routerLink="/New-Showcase" routerLinkActive="active"
            style="border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;"
            class="mx-1 px-8 py-1 text-xl font-light cursor-pointer bg-headerfr hover:bg-buttonhover text-yellow-200 hover:text-colortext place-self-center mt-4">Add
            a
            new showcase
        </button>
    </div>
    <div class="flex flex-col-2 justify-center items-center">
        <div class="bg-white flex items-center w-1/4 rounded-full shadow-2xl relative">
            <input autocomplete="off"
                class="rounded-l-full w-full py-4 px-6 text-gray-700 leading-tight focus:outline-none" id="search"
                type="text" placeholder="Search" [(ngModel)]="searchArray" (keypress)="onSearchKeypress($event)" />
            <div class="p-1">
                <button
                    class="bg-evaluationto text-white rounded-full p-2 hover:bg-evaluationto focus:outline-none w-12 h-12 flex items-center justify-center"
                    (click)="applySearch()">
                    <mat-icon>search</mat-icon>
                </button>
            </div>
        </div>
        <div class="flex justify-center mx-6">
            <button style="border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;"
                class="mx-1 px-8 py-1 text-xl font-light cursor-pointer bg-headerfr hover:bg-buttonhover text-yellow-200 hover:text-colortext place-self-center"
                (click)="openMap()">
                <div class="flex flex-col justify-center items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" height="45" style="fill: #FFF9C4;" class="place-self-center"
                        viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                        <path
                            d="M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152V422.8c0 9.8-6 18.6-15.1 22.3L416 503V200.4zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6V451.8L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77V504.3L192 449.4V255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z" />
                    </svg> View on Map
                </div>
            </button>
        </div>
    </div>
    <div class="flex justify-between">
        <div class="flex flex-col items-center shadow ml-4 w-1/6 sm:rounded-md sm:overflow-hidden bg-white mt-16 p-4"
            style="height: 40vh;">
            <!-- Filters -->
            <ul class="mt-8">
                <li
                    class="flex flex-col items-center w-full justify-between text-gray-600 hover:text-gray-500 cursor-pointer mb-6">
                    <span class="flex text-sm">Country</span>
                    <link href="https://cdn.jsdelivr.net/npm/@tailwindcss/custom-forms@0.2.1/dist/custom-forms.css"
                        rel="stylesheet" />
                    <label class="block text-left" style="width: 100%!important">
                        <select [disabled]="docCountries.length == 0" (change)="applyFilter()"
                            class="form-select block w-full mt-1" [(ngModel)]="filterCountry">
                            <option class="text-black" *ngFor="let country of docCountries">{{country}}</option>
                        </select>
                    </label>
                </li>
                <li
                    class="flex flex-col items-center w-full justify-between text-gray-600 hover:text-gray-500 cursor-pointer mb-6">
                    <span class="flex text-sm">Keyword</span>
                    <link href="https://cdn.jsdelivr.net/npm/@tailwindcss/custom-forms@0.2.1/dist/custom-forms.css"
                        rel="stylesheet" />
                    <label class="block text-left" style="width: 100%!important">
                        <select [disabled]="docKeywords.length == 0" (change)="applyFilter()"
                            class="form-select block w-full mt-1" [(ngModel)]="filterKeywords">
                            <option class="text-black" *ngFor="let keyword of docKeywords">{{keyword}}</option>
                        </select>
                    </label>
                </li>
            </ul>
            <button (click)="resetFilters()" class="my-4 bg-red-400 hover:bg-red-500 rounded text-white p-2">
                Reset Filters
            </button>
        </div>
        <div *ngIf="showResults"
            class="flex-initial shadow w-3/4 sm:rounded-md sm:overflow-hidden bg-white mt-16 ml-16 p-4">
            <div>
                <label>Results ({{results.length}})</label>
                <div class="hidden sm:block" aria-hidden="true">
                    <div class="py-5">
                        <div class="border-t border-gray-200"></div>
                    </div>
                </div>
                <div *ngIf="noResults" class="text-center">
                    <div class="text-gray-800 text-lg font-semibold">Your search did not match any documents.</div>
                    <br>
                    <div class="text-gray-600 text-sm font-normal">&#x2022; Make sure your search terms are spelled
                        correctly.</div>
                    <div class="text-gray-600 text-sm font-normal">&#x2022; Try different keywords.</div>
                </div>
            </div>
            <div *ngIf="loading">
                <div class="grid">
                    <div class="place-self-center">
                        <mat-spinner></mat-spinner>
                    </div>
                </div>
            </div>
            <!-- results list -->
            <div *ngFor="let result of results">
                <div class="w-11/12 py-4 px-8 bg-white shadow-2xl rounded-lg mx-12 my-8">
                    <div class="flex flex-col">
                        <h5 class="text-gray-800 text-xl font-semibold">{{result.title}}</h5>
                        <div class="hidden sm:block" aria-hidden="true">
                            <div class="py-5">
                                <div class="border-t border-gray-200"></div>
                            </div>
                        </div>
                        <p class="overflow-y-auto h-12 mt-2 text-gray-600" [innerHTML]="result.summary"></p>
                        <button
                            class="justify-self-end self-end w-1/6 my-4 bg-red-400 hover:bg-red-300 rounded text-white p-2 pl-4 pr-4"
                            (click)="goToView(result.id)">
                            See more
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>